import { useLogs } from "../../../hooks/useFetch";
import React, { useMemo } from "react";
import { IUser } from "../../../types/userType";
import { ILog } from "../../../types/logType";
import { OutletType } from "admin/src/types";

type LogTableProps = {
	datas?: LogsType[];
};

type LogsType = {
	timestamp?: string;
	action?: string;
};

const defaultProps: LogTableProps = {
	datas: [{ timestamp: "today", action: "write" }],
};

const LogsTable = ({ context }: OutletType<IUser>): JSX.Element => {
	const [logs] = useLogs(
		useMemo<Partial<ILog>>(() => {
			return { target: context._id };
		}, [context])
	);

	return (
		<div className=" border-gray-200 w-full">
			<table className="w-full">
				<tbody>
					{logs?.map((data, index) => {
						return (
							<tr
								className={`${
									index % 2 === 0 && "bg-gray-50"
								} px-4 py-5 sm:gap-4 sm:px-6`}
								key={index}
							>
								<td
									className={`text-sm py-2 text-slate-700 font-bold
                  `}
								>
									[
									{
										// Turn date into readable format

										new Date(data?.time || "").toLocaleDateString("id-ID", {
											timeZone: "Asia/Makassar",
											year: "numeric",
											month: "long",
											day: "numeric",
											hour: "numeric",
											minute: "numeric",
										})
									}
									]
								</td>
								<td className="mt-1 text-sm text-gray-900">{data?.user}</td>
								<td className="text-sm">{data?.action || ""}</td>
								<td className="text-sm">{data?.target || ""}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

LogsTable.defaultProps = defaultProps;

export default LogsTable;
